import { chat, chatMeta, enqueueLottieEffect } from '../../stores/chat';
import { meta } from '../../stores/backend';
import { ChatSocket } from '../../hooks/use-socket';
import { ChatPost } from '../../types/bingo-events/in/chat/post';
import { isChatLottieEffectTrigger } from '../../lib/lottie-effect-triggers';

export const onPost = (socket: ChatSocket) => {
    const callback = (response: ChatPost) => {
        if (isChatLottieEffectTrigger(response)) {
            enqueueLottieEffect(response.message);
            return;
        }

        if (response.postLevel === 2) {
            meta.modals.msgCommon.set({
                name: response.message,
                isOpen: true,
                closeBehavior: 'close',
            });
        } else if (response.postLevel === 3) {
            chat.messages.merge([
                {
                    ...response,
                    isSystemMsg: true,
                    bannedWord: true,
                    isWelcomeMsg: false,
                },
            ]);
        } else {
            chat.messages.merge([
                {
                    ...response,
                    isSystemMsg: response.postLevel !== 1,
                    isWelcomeMsg: false,
                },
            ]);

            if (
                (response.message.match(`@${chat.currentPlayer.name?.value}`) ||
                    response.pm) &&
                !chatMeta.chatToggle.value
            ) {
                chatMeta.mentions.set(chatMeta.mentions.value + 1);
            }
        }
    };

    socket.on('post:parlay', callback);

    return () => {
        socket.off('post:parlay', callback);
    };
};
